import {Alert, Snackbar} from '@mui/material'
import React from 'react'
import {createRoot} from 'react-dom/client'

// A single persistent root attached to #modal. We deliberately do NOT unmount it
// between alerts: unmounting and then re-rendering on the same root throws
// ("render on an unmounted root"), which previously bubbled up into callers and
// could, for example, block the post-publish redirect. A monotonic key re-shows
// the Snackbar each time; autoHideDuration hides it. Everything is wrapped so a
// toast failure can never break the calling flow.
let root = null
let alertKey = 0

const AutoHideAlert = ({message, type}) => {
  const [open, setOpen] = React.useState(true)

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') return
    setOpen(false)
  }

  return (
    <Snackbar
      anchorOrigin={{vertical: 'top', horizontal: 'center'}}
      open={open}
      autoHideDuration={3000}
      onClose={handleClose}
    >
      <Alert variant="filled" severity={type} onClose={handleClose}>
        {message}
      </Alert>
    </Snackbar>
  )
}

const WbAlert = ({message, type}) => {
  try {
    const container = document.querySelector('#modal')
    if (!container) return
    if (!root) {
      root = createRoot(container)
    }
    alertKey += 1
    root.render(<AutoHideAlert key={alertKey} message={message} type={type} />)
  } catch (e) {
    // Never let a toast failure break the caller (publish redirect, etc.).
  }
}

export default WbAlert
